module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box about-us"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_c('h1', [_vm._v("Who we are & what we stand for")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform trust-us about-us-simple-idea"
  }, [_c('div', {
    staticClass: "row trust-us-box"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 trust-us-inner-left"
  }, [_c('div', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "trust-us-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")])])])]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "American Credit Team Customer Voice Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text"
  }, [_vm._v("I need to spend my time meeting customers’ expectations, not on lengthy loan applications.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("Let’s Talk")]), _vm._v(" "), _vm._m(8)])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform meet-founding-team"
  }, [_c('div', {
    staticClass: "row meet-founding-team-box"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 meet-founding-team-inner-left"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "18px"
    },
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "American Credit Business Loans Meet Founding Team Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text"
  }, [_vm._v("The dilemma in the current equipment financing market: often financing & purchases are bundled. American Credit’s dedicated fintech platform for secured loans is a solution to that problem.")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("Let’s Talk")]), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _vm._m(11)])])]), _vm._v(" "), _vm._m(12)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Try us now. See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "about-us-main-img",
    attrs: {
      "src": require("../assets/imgs/American_Credit_About_Us.png"),
      "alt": "American Credit About Us"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row platform-for-success"
  }, [_c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container platform-for-success-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v("A platform for success whatever your business")]), _vm._v(" "), _c('div', {
    staticClass: "row text-left"
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticClass: "platform-for-success-card"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Platform_for_Success_Whatever_Your_Business.png"),
      "alt": "American Credit Platform for Success Whatever Your Business"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "platform-for-success-text"
  }, [_vm._v("Whether you have a construction company, used car dealership, dental office, welding shop")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "hover-element"
  }, [_c('p', [_c('span', {
    staticClass: "platform-for-success-read-more"
  }, [_c('a', [_vm._v("Read more "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("or virtually any other business, we support you in spirit and practice. Our platform evaluates your business based on its real-life performance, not just your credit score—enabling us to offer you funding on a responsible basis at reasonable terms.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticClass: "platform-for-success-card"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/American_Credit_Platform_for_Success_Most_Profitable.png"),
      "alt": "American Credit Platform for Success Most Profitable"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "platform-for-success-text"
  }, [_vm._v("We want you to be able to devote time to where it's most profitable")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "hover-element"
  }, [_c('p', [_c('span', {
    staticClass: "platform-for-success-read-more"
  }, [_c('a', [_vm._v("Read more "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("running your business and serving your clientele—instead of chasing business financing. And from the moment you apply for a loan to the end of its term, your American Credit personal assistant is available to support you.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticClass: "platform-for-success-card"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/American_Credit_Platform_for_Sucess_Credit_Score_OK.png"),
      "alt": "American Credit Platform for Sucess Credit Score OK"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "platform-for-success-text"
  }, [_vm._v("And remember, a less-than-prime credit score is OK.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "hover-element"
  }, [_c('p', [_c('span', {
    staticClass: "platform-for-success-read-more"
  }, [_c('a', [_vm._v("Read more "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "hover-display-content"
  }, [_vm._v("The American Credit lending platform allows us take into account more than your credit score. Which means a moderate score doesn’t disqualify you for an American Credit asset backed loan. See what you can borrow.")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trust-us-title"
  }, [_vm._v("Secured loans take up about 1/5 of the size of GDP"), _c('sup', [_vm._v("1")]), _vm._v(". We are a dedicated fintech platform for secured loans.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trust-us-text"
  }, [_c('span', {
    staticStyle: {
      "color": "#686868",
      "font-weight": "300"
    }
  }, [_vm._v("We started with a simple idea: the secured loan market has to keep pace with the digital age. We believe that small and medium businesses shouldn’t be deprived of the opportunity to enjoy the benefit of a fintech revolution to fuel their companies.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 trust-us-inner-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_About_Us_Simple_Idea.png"),
      "alt": "American Credit About Us Simple Idea"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Team_Customer_Voice.png"),
      "alt": "American Credit Team Customer Voice"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "300"
    }
  }, [_vm._v("Laurie Townsend")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("Account Receivable Manager, Lone Star Uniform Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300"
    }
  }, [_vm._v("Try us now. ")]), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "700"
    }
  }, [_vm._v("Dr. Lei Li")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("American Credit Founder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300",
      "margin-left": "15px"
    }
  }, [_vm._v("Meet the founding team. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 meet-founding-team-inner-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Meet_Founding_Team.png"),
      "alt": "American Credit Business Loans Meet Founding Team"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px",
      "font-family": "Biotif",
      "font-weight": "400",
      "font-size": "14px"
    }
  }, [_vm._v("\n              Footnote\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding-left": "15px"
    }
  }, [_c('li', {
    staticStyle: {
      "list-style": "decimal",
      "font-family": "Biotif",
      "font-weight": "400",
      "font-size": "14px"
    }
  }, [_vm._v("Source: Commercial Finance Association Education Foundation")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9041c9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutUs.vue
// module id = 2018
// module chunks = 5